import { render, staticRenderFns } from "./hrd-update-new-trainee.vue?vue&type=template&id=b65667a4&scoped=true"
import script from "./hrd-update-new-trainee.vue?vue&type=script&lang=js"
export * from "./hrd-update-new-trainee.vue?vue&type=script&lang=js"
import style0 from "./hrd-update-new-trainee.vue?vue&type=style&index=0&id=b65667a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65667a4",
  null
  
)

export default component.exports